import { render, staticRenderFns } from "./RiverList.vue?vue&type=template&id=3a30d5da&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./RiverList.vue?vue&type=script&lang=js&"
export * from "./RiverList.vue?vue&type=script&lang=js&"
import style0 from "./RiverList.vue?vue&type=style&index=0&id=3a30d5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30d5da",
  null
  
)

export default component.exports